module.exports = __webpack_public_path__ + "img/tablero-pendiente.2e6be073.svg";